/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gold_Jade_Buck_HoldInputs */

const en_gold_jade_buck_hold = /** @type {(inputs: Gold_Jade_Buck_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peer Feedback`)
};

const de_gold_jade_buck_hold = /** @type {(inputs: Gold_Jade_Buck_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peer Feedback`)
};

/**
* | output |
* | --- |
* | "Peer Feedback" |
*
* @param {Gold_Jade_Buck_HoldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gold_jade_buck_hold = /** @type {((inputs?: Gold_Jade_Buck_HoldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gold_Jade_Buck_HoldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gold_jade_buck_hold(inputs)
	return de_gold_jade_buck_hold(inputs)
});